import React from 'react';
import { Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

const HealthVideoList = (props) => {
    return (
        <Item.Group divided>
            {
                _.map(props.videos, (video) => {
                    const {
                        id,
                        snippet,
                    } = video;
                    const {
                        thumbnails,
                        title
                    } = snippet;
                    return (
                        <Item key={id}>
                            <Item.Image src={thumbnails.standard.url} />
                            <Item.Content>
                                <Item.Header>
                                    <Link to={`/app/healtharticles/view?type=2&id=${id}`}>
                                        {title}
                                    </Link>
                                </Item.Header>
                            </Item.Content>
                        </Item>
                    );
                })
            }
        </Item.Group>
    );
}

export default HealthVideoList;